export interface PartnerLightData {
  id: string;
  name: string;
}

export namespace PartnerLightData {
  export function mapFromApiValue(partner: any): PartnerLightData {
    return {
      ...partner,
    };
  }
}

export const DEMO_PARTNER_LIGHT: PartnerLightData = {
  id: '-1',
  name: 'Demo Partner',
};
